import React, { FunctionComponent } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import Styles from 'components/leftNavBar/LeftNavBar.module.scss';
import logoutIcon from 'assets/svg/logout.svg';
import { useDispatch } from 'react-redux';
import { callLogout } from 'store/actions/auth.actions';

interface LeftNavBarProps {
  onLinkClick?: () => void;
}

const LeftNavBar: FunctionComponent<LeftNavBarProps> = ({ onLinkClick }) => {
  const location = useLocation();
  const history = useHistory();
  const path = location.pathname;
  const dispatch = useDispatch();
  const handleLogOut = () => {
    dispatch(callLogout());
    history.push('/login');
  };

  const handleClick = () => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <>
      <ul className={`list-unstyled ${Styles.listingWrapper}`}>
        <li className={`fontSixteen text-black poppins-bold ${Styles.listingTitle}`}>GENERAL</li>
        <li className={`${path === '/explainer-video' && Styles.active}`}>
          {/* <a
            className="fontFifteen poppins-regular text-decoration-none"
            href="https://www.youtube.com/watch?v=JQrPpj7b0_g"
            target="_blank"
            rel="noreferrer"
          >
            Explainer Video
          </a> */}
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/explainer-video" onClick={handleClick}>
            Explainer Video
          </Link>
        </li>
        <li className={`${path === '/invite-friend' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/invite-friend" onClick={handleClick}>
            Invite a Friend
          </Link>
        </li>
        <li className={`fontSixteen text-black poppins-bold ${Styles.listingTitle}`}>ACCOUNT</li>
        <li className={`${path === '/currency' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/currency" onClick={handleClick}>
            Currency
          </Link>
        </li>
        <li className={`${path === '/subscription' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/subscription" onClick={handleClick}>
            Subscription
          </Link>
        </li>
        <li className={`${path === '/profile/edit' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/profile/edit" onClick={handleClick}>
            Edit Profile
          </Link>
        </li>
        <li className={`${path === '/date-and-time' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/date-and-time" onClick={handleClick}>
            Date and Time
          </Link>
        </li>
        <li className={`${path === '/notifications' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/notifications" onClick={handleClick}>
            Notifications
          </Link>
        </li>
        <li className={`${path === '/email-notifications' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/email-notifications" onClick={handleClick}>
            Email Notifications
          </Link>
        </li>
        <li className={`fontSixteen text-black poppins-bold ${Styles.listingTitle}`}>OTHER</li>
        <li className={`${path === '/feedback' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/feedback" onClick={handleClick}>
            Send Us Feedback
          </Link>
        </li>
        <li className={`${path === '/terms-and-conditions' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/terms-and-conditions" onClick={handleClick}>
            Terms & Conditions
          </Link>
        </li>
        <li className={`${path === '/privacy-policy' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/privacy-policy" onClick={handleClick}>
            Privacy Policy
          </Link>
        </li>
        <li className={Styles.logOut}>
          <div className={Styles.btnStyle} onClick={handleLogOut} onKeyPress={handleLogOut} role="button" tabIndex={0}>
            LogOut
            <img src={logoutIcon} alt="logout icon" />
          </div>
        </li>
      </ul>
    </>
  );
};

export default LeftNavBar;
